import dayjs from 'dayjs';

import {
    CommonEventStatusEnum,
    EventAgeEnum,
    EventDetailType,
    EventFormType,
    EventRequestType,
    EventTypeEnum,
} from '../../../service/events/events-type';
import {ProvidersIdsEnum} from '../../../util/type';

export const EVENT_SELECT_COMPANIES_STEP_WIDTH = 864;
export const EVENT_MEDIA_STEP_WIDTH = 704;
export const EVENT_DETAILS_STEP_WIDTH = 704;

// Catalogs are hidden from the UI for now — events always target Yandex.
const EVENT_CATALOG_IDS = [ProvidersIdsEnum.yandex];

export function getEventFormInitialValues(event: EventDetailType): EventFormType {
    return {
        title: event.title,
        description: event.description,
        eventType: event.eventType,
        minAge: event.minAge,
        catalogsIds: event.catalogsIds,
        images: event.images,
        publishAt: event.publishAt ? dayjs(event.publishAt) : null,
        deletedAt: event.deletedAt ? dayjs(event.deletedAt) : null,
        startAt: event.startAt ? dayjs(event.startAt) : null,
        finishAt: event.finishAt ? dayjs(event.finishAt) : null,
    };
}

export function prepareEventRequestData(
    values: EventFormType,
    selectorId: string,
    status: CommonEventStatusEnum
): EventRequestType {
    return {
        title: values.title,
        description: values.description ?? '',
        eventType: values.eventType ?? EventTypeEnum.Occasion,
        minAge: values.minAge ?? EventAgeEnum.Age0,
        selectorId,
        catalogsIds: EVENT_CATALOG_IDS,
        publishAt: values.publishAt ? values.publishAt.toISOString() : null,
        deletedAt: values.deletedAt ? values.deletedAt.toISOString() : null,
        startAt: values.startAt ? values.startAt.toISOString() : '',
        finishAt: values.finishAt ? values.finishAt.toISOString() : '',
        imageIds: (values.images ?? []).map((image) => image.id),
        status,
    };
}
